function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { GET_USER_REPORTS_SUCCESS, GET_USER_REPORTS_REQUESTED, GET_USER_REPORT_WRITER_RESULTS_REQUESTED, GET_USER_REPORT_WRITER_RESULTS_SUCCESS, ADD_REPORT } from '../actions/reportActions';
var initialState = {
  reports: [],
  reportWriterResults: [],
  isLoading: false
};
export default function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case GET_USER_REPORTS_SUCCESS:
      return Object.assign({}, state, {
        reports: payload,
        isLoading: false
      });
    case GET_USER_REPORTS_REQUESTED:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case GET_USER_REPORT_WRITER_RESULTS_SUCCESS:
      return Object.assign({}, state, {
        reportWriterResults: payload,
        isLoading: false
      });
    case GET_USER_REPORT_WRITER_RESULTS_REQUESTED:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case ADD_REPORT:
      return Object.assign({}, state, {
        reports: [].concat(_toConsumableArray(state.reports), [payload])
      });
    default:
      return state;
  }
}